export default __webpack_public_path__ + "static/media/108_mobile.61a9019c.jpg";